import React from 'react';
import Icon from '../../../components/AppIcon';

const ProgramInfoPanel = () => {
  const benefits = [
    {
      icon: 'DollarSign',
      title: 'Commissions Attractives',
      description: 'Jusqu\'à 15% de commission sur chaque booking réussi'
    },
    {
      icon: 'Users',
      title: 'Réseau Étendu',
      description: 'Accès à plus de 2,000 artistes et 500 lieux partenaires'
    },
    {
      icon: 'BarChart3',
      title: 'Outils Analytics',
      description: 'Tableaux de bord détaillés pour suivre vos performances'
    },
    {
      icon: 'Headphones',
      title: 'Support Dédié',
      description: 'Équipe support spécialisée dans l\'industrie musicale'
    }
  ];

  const commissionStructure = [
    { type: 'Booking Standard', rate: '8-12%', description: 'Événements réguliers et clubs' },
    { type: 'Festivals', rate: '10-15%', description: 'Grands événements et festivals' },
    { type: 'Événements Privés', rate: '12-18%', description: 'Mariages, corporate, privé' },
    { type: 'Bonus Performance', rate: '+5%', description: 'Objectifs mensuels atteints' }
  ];

  const steps = [
    {
      number: 1,
      title: 'Inscription',
      description: 'Complétez le formulaire en 3 étapes simples'
    },
    {
      number: 2,
      title: 'Validation',
      description: 'Vérification de votre profil sous 48h'
    },
    {
      number: 3,
      title: 'Formation',
      description: 'Accès aux outils et ressources partenaires'
    },
    {
      number: 4,
      title: 'Activation',
      description: 'Commencez à générer des revenus'
    }
  ];

  return (
    <div className="space-y-6">
      {/* Welcome Section */}
      <div className="bg-gradient-to-br from-accent/10 to-accent/5 border border-accent/20 rounded-lg p-6">
        <div className="flex items-center space-x-3 mb-4">
          <div className="flex items-center justify-center w-10 h-10 bg-accent rounded-lg">
            <Icon name="Music" size={20} color="white" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Bienvenue chez Artis.io</h2>
            <p className="text-sm text-muted-foreground">Programme d'affiliation musical</p>
          </div>
        </div>
        <p className="text-sm text-foreground">
          Rejoignez la plateforme leader qui connecte les professionnels de la musique 
          avec les meilleurs lieux et événements en Europe.
        </p>
      </div>
      {/* Benefits */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Pourquoi nous rejoindre ?
        </h3>
        <div className="space-y-4">
          {benefits?.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex items-center justify-center w-8 h-8 bg-accent/10 rounded-lg">
                <Icon name={benefit?.icon} size={16} className="text-accent" />
              </div>
              <div>
                <h4 className="font-medium text-foreground text-sm">{benefit?.title}</h4>
                <p className="text-xs text-muted-foreground">{benefit?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Commission Structure */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Structure des Commissions
        </h3>
        <div className="space-y-3">
          {commissionStructure?.map((commission, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-muted rounded-lg">
              <div>
                <h4 className="font-medium text-foreground text-sm">{commission?.type}</h4>
                <p className="text-xs text-muted-foreground">{commission?.description}</p>
              </div>
              <div className="text-right">
                <span className="font-semibold text-accent">{commission?.rate}</span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 p-3 bg-success/10 border border-success/20 rounded-lg">
          <p className="text-xs text-success">
            <Icon name="TrendingUp" size={14} className="inline mr-1" />
            Paiements mensuels automatiques • Seuil minimum: 100€
          </p>
        </div>
      </div>
      {/* Process Steps */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Processus d'inscription
        </h3>
        <div className="space-y-4">
          {steps?.map((step, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="flex items-center justify-center w-6 h-6 bg-accent text-accent-foreground rounded-full text-xs font-medium">
                {step?.number}
              </div>
              <div>
                <h4 className="font-medium text-foreground text-sm">{step?.title}</h4>
                <p className="text-xs text-muted-foreground">{step?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Statistics */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Nos Chiffres
        </h3>
        <div className="grid grid-cols-2 gap-4">
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-xl font-bold text-accent">2,000+</div>
            <div className="text-xs text-muted-foreground">Artistes</div>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-xl font-bold text-accent">500+</div>
            <div className="text-xs text-muted-foreground">Lieux</div>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-xl font-bold text-accent">15K+</div>
            <div className="text-xs text-muted-foreground">Événements</div>
          </div>
          <div className="text-center p-3 bg-muted rounded-lg">
            <div className="text-xl font-bold text-accent">€2.5M</div>
            <div className="text-xs text-muted-foreground">Commissions</div>
          </div>
        </div>
      </div>
      {/* Contact Support */}
      <div className="bg-surface border border-border rounded-lg p-6">
        <h3 className="text-lg font-semibold text-foreground mb-4">
          Besoin d'aide ?
        </h3>
        <div className="space-y-3">
          <div className="flex items-center space-x-3">
            <Icon name="Mail" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">partners@artis.io</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="Phone" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">+33 1 23 45 67 89</span>
          </div>
          <div className="flex items-center space-x-3">
            <Icon name="MessageCircle" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">Chat en direct disponible</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramInfoPanel;